import { useEffect, useState } from 'react';

import { useDocumentVisibility } from '../../../../../hooks/use-document-visibility';
import { DayPeriod, getDayPeriod } from './time-based-images';

const DAY_PERIOD_START_HOURS = [5, 12, 18];

const getMillisecondsUntilNextDayPeriod = (date: Date): number => {
  const nextPeriodStart = new Date(date);
  const nextPeriodStartHour = DAY_PERIOD_START_HOURS.find((hour) => hour > date.getHours());

  if (nextPeriodStartHour === undefined) {
    nextPeriodStart.setDate(nextPeriodStart.getDate() + 1);
    nextPeriodStart.setHours(DAY_PERIOD_START_HOURS[0], 0, 0, 0);
  } else {
    nextPeriodStart.setHours(nextPeriodStartHour, 0, 0, 0);
  }

  return nextPeriodStart.getTime() - date.getTime();
};

export const useDayPeriod = (): DayPeriod => {
  const [dayPeriod, setDayPeriod] = useState<DayPeriod>(() => getDayPeriod());
  const isDocumentVisible = useDocumentVisibility();

  useEffect(() => {
    if (!isDocumentVisible) {
      return undefined;
    }

    const updateDayPeriod = () => setDayPeriod(getDayPeriod());

    updateDayPeriod();

    const timeoutId = window.setTimeout(
      updateDayPeriod,
      getMillisecondsUntilNextDayPeriod(new Date()),
    );

    return () => window.clearTimeout(timeoutId);
  }, [dayPeriod, isDocumentVisible]);

  return dayPeriod;
};

